/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ProfileAction
 */
export interface ProfileAction {
    /**
     *
     * @type {boolean}
     * @memberof ProfileAction
     */
    readonly success: boolean;
    /**
     *
     * @type {string}
     * @memberof ProfileAction
     */
    readonly message: string;
}

/**
 * Check if a given object implements the ProfileAction interface.
 */
export function instanceOfProfileAction(value: object): value is ProfileAction {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function ProfileActionFromJSON(json: any): ProfileAction {
    return ProfileActionFromJSONTyped(json, false);
}

export function ProfileActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileAction {
    if (json == null) {
        return json;
    }
    return {

        'success': json['success'],
        'message': json['message'],
    };
}

  export function ProfileActionToJSON(json: any): ProfileAction {
      return ProfileActionToJSONTyped(json, false);
  }

  export function ProfileActionToJSONTyped(value?: Omit<ProfileAction, 'success'|'message'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

    };
}
